import { render, staticRenderFns } from "./Personnel.vue?vue&type=template&id=32c9ec51&scoped=true&"
import script from "./Personnel.vue?vue&type=script&lang=js&"
export * from "./Personnel.vue?vue&type=script&lang=js&"
import style0 from "./Personnel.vue?vue&type=style&index=0&id=32c9ec51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c9ec51",
  null
  
)

export default component.exports